/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import EventCardLine from './lineCard';
import moment from 'moment';
import { deferImport } from 'client/src/utils/deferImport';
import available from '/client/src/utils/DOM_available';
import { format } from '/client/src/utils/amountTransformation';
import { currency } from '/client/src/constants/';
import { convertToLocalTime } from '/client/src/utils/jstz';


const EventCardChart = React.lazy(
  (): Promise => deferImport(import('./../../components/charts/eventCard.jsx'), 1000),
  { async: true }
);

type PropsType = {
  id?: string,
  name?: string,
  location?: string,
  begin_time_utc?: string,
  end_time_utc?: string,
  time_zone_id?: string,
  transactions?: {
    [string]: any
  },
  setEventList: () => void,
  eventList: []
};

class EventCardLineCharts extends React.PureComponent<PropsType> {
  generateData = (): [] => {
    const data = [];

    for (let i = 6; i >= 0; i--) {
      data.push({
        name: moment().subtract(i, 'days').format('MM/DD'),
        pv: 0
      });
    }

    return data;
  };

  state = {
    dataAmount: this.generateData(),
    dataTickets: this.generateData(),
    earned: 0,
    sold: 0,
    view: 0
  };


  componentDidMount = () => {
    const stats = _.get(this.props, 'transactions.stats', false);

    if (!!stats) {
      const _dataAmount = _.clone(this.state.dataAmount);
      const _dataTickets = _.clone(this.state.dataTickets);

      _.map(stats, (item: {}, index: number): {} => {
        const soldDay = item.sold_quantity - item.return_quantity;
        const earnedDay = item.amount - item.amount_refund;

        this.setState({
          earned: this.state.earned + earnedDay,
          sold: this.state.sold + soldDay,
          view: 0
        });
        _dataTickets[index].pv = soldDay;
        _dataAmount[index].pv = earnedDay;
      });

      this.setState({
        dataAmount: _dataAmount,
        dataTickets: _dataTickets
      });
    }
  };

  render(): React.Element<'div'> {
    const document = available<{ body?: HTMLBodyElement }>('document', { body: null });
    const {
      id,
      name,
      location,
      begin_time_utc,
      end_time_utc,
      time_zone_id
    } = this.props;

    const {
      dataAmount,
      dataTickets,
      earned
      // sold
    } = this.state;

    const startTime = begin_time_utc ? convertToLocalTime(begin_time_utc, time_zone_id, 'MMM Do, h:mm A') : '';
    const endTime = end_time_utc ? convertToLocalTime(end_time_utc, time_zone_id, 'MMM Do, h:mm A z') : '';
    
     
    // const today = _.last(_.get(this.props, 'transactions.stats', false));
    const views = _.get(this.props, 'event_total_views', 0);
    const soldTotal = _.get(this.props, 'transactions.sold_quantity', 0) - _.get(this.props, 'transactions.return_quantity', 0);
    const amountTotal = _.get(this.props, 'transactions.merchant_ticket_revenue', 0) - _.get(this.props, 'transactions.merchant_ticket_revenue_refund', 0);
    const currentCurrency = _.get(this.props, 'transactions.currency', 'USD');


    return (
      <EventCardLine className='chart' id={id} startDate={begin_time_utc} {...this.props}>
        <div className="EventCardLine-col">
          <div className="EventCardLine-description">
            <h4>{name}</h4>

            <p>{startTime} - {endTime}</p>
            <p>{location}</p>
          </div>
        </div>

        <div className="EventCardLine-col">
          <div className="EventCardLine-tickets">
            <h4>Tickets sold<span>{soldTotal}</span></h4>
             <React.Suspense fallback={<div>Loading...</div>}>
              {document.body ?
              <EventCardChart async data={dataTickets} /> : null}
             </React.Suspense>
          </div>
        </div>

        <div className="EventCardLine-col">
          <div className="EventCardLine-tickets">
            {/* TODO: if in ticker different currency? */}
            <h4>AMOUNT earned <span>{format(currency[currentCurrency], amountTotal)}</span></h4>

            <React.Suspense fallback={<div>Loading...</div>}>
              {document.body ?
              <EventCardChart async data={dataAmount} /> : null}
            </React.Suspense>
          </div>
        </div>

         <div className="EventCardLine-col">
          <div className="EventCardLine-tickets">
            <h4>Total views</h4>
            <p>{views}</p>
          </div>
         </div>

        <div className="EventCardLine-col">
          <div className="EventCardLine-tickets">
            <h4>Tickets sold</h4>

            <p>
              {/* {!!today ? today.sold_quantity - today.return_quantity : '0'} */}
              {soldTotal}
            </p>
          </div>
        </div>
      </EventCardLine>
    );
  }
}

EventCardLineCharts.defaultProps = {
  begin_time_utc: null,
  end_time_utc: null,
  transactions: {
    sold_quantity: '-',
    ticket_quantity_expected: '-',
    amount: '-',
    merchant_revenue: '-'
  }
};

export default EventCardLineCharts;
